import { render } from "./InitiativeForm.vue?vue&type=template&id=daf72f1a&scoped=true"
import script from "./InitiativeForm.vue?vue&type=script&lang=js"
export * from "./InitiativeForm.vue?vue&type=script&lang=js"

import "./InitiativeForm.vue?vue&type=style&index=0&id=daf72f1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daf72f1a"]])

export default __exports__